// extracted by mini-css-extract-plugin
export default {"Layout":"Layout_Layout__fNo3R","Main":"Layout_Main__zBpRw","Region":"Layout_Region__-PrZu","Index":"Layout_Index__-4sp3"};